const XSS_SECURITY_URL = "https://cheatsheetseries.owasp.org/cheatsheets/Cross_Site_Scripting_Prevention_Cheat_Sheet.html";
const SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:\/?#]*(?:[\/?#]|$))/i;
const sanitizeUrl = (url) => {
  url = String(url);
  if (url.match(SAFE_URL_PATTERN)) {
    return url;
  }
  console.warn(`WARNING: sanitizing unsafe URL value ${url} (see ${XSS_SECURITY_URL})`);
  return "unsafe:" + url;
};
export {
  sanitizeUrl
};
